import styled from "styled-components";
import Button, {
  buttonThemes
} from "@streeteasy/design-system/deprecated/actions/button";
import DSSidePanel from "@streeteasy/design-system/side-panel";

export const SidePanel = styled(DSSidePanel).attrs({
  style: {
    overlay: {
      zIndex: 1000
    }
  }
})``;

const ActionButton = styled(Button)`
  width: 100%;
`;

export const PrimaryActionButton = styled(ActionButton).attrs({
  theme: buttonThemes.PRIMARY
})``;

export const SecondaryActionButton = styled(ActionButton).attrs({
  theme: buttonThemes.SECONDARY
})``;
